// 案件列表页面翻译
export default {
  // 页面标题
  pageTitle: "研判分析-案件分析",
  switchToOldVersion: "切到老版本",
  switchToNewVersion: "切到新版本",

  // 顶部按钮
  allCases: "所有案件",
  myCases: "我的案件",
  createCase: "新建案件",

  // 搜索表单
  searchForm: {
    caseNamePlaceholder: "请输入案件名称",
    creatorNamePlaceholder: "请输入创建人姓名",
    startDate: "开始日期",
    endDate: "结束日期",
    rangeSeparator: "→",
  },

  // 统计信息
  totalData: "共计",
  dataUnit: "条数据",

  // 表格列
  tableColumns: {
    index: "序号",
    caseName: "案件名称",
    caseDescription: "案件说明",
    caseType: "案件类型",
    creator: "创建人",
    createTime: "创建时间",
    updateTime: "更新时间",
    operation: "操作",
  },

  // 操作按钮
  actions: {
    edit: "修改",
    analyze: "分析",
    delete: "删除",
  },

  // 确认对话框
  confirmDialog: {
    deleteTitle: "删除确认",
    deleteMessage: "此操作将永久删除{caseName}案件, 是否确定?",
    confirmButton: "确定",
    cancelButton: "取消",
  },

  // 消息提示
  messages: {
    deleteSuccess: "删除成功",
    deleteCancelled: "已取消删除",
    noPermission: "您没有权限访问该页面",
  },

  // 加载状态
  loading: "拼命加载中",

  // 空状态
  emptyText: "暂无数据",
};
